import React from "react";
import { Formik, Field, Form } from "formik";
import { Link } from "react-router-dom";
import { ScriptTag } from "seed/helpers";
import { Loading } from "seed/helpers";
import { Analytics } from "components/util/analytics";
import PasswordField from "components/util/helpers/PasswordField";
import l from "components/util/l";
import StyleColor from "components/util/helpers/StyleColor"


const LoginView = ({ error, isLoading, onSubmit, onMicrosoftLogin, onGoogleLogin }) =>

  <main id="content" role="main" class="main pl-0 h-100 w-100" style={{ overflowY: "auto" }}>
    <StyleColor />
    <div class="container py-4 py-sm-6">
      <a class="d-flex justify-content-center mb-4 mb-md-5" href={"/"}>
        <img class="z-index-2 pr-4 w-50"
          src="/theme/svg/logos/logo-white.svg" alt="Logo" style={{ maxHeight: "2.5rem" }} />
      </a>

      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 px-2 px-md-3">
          <div class="card card-lg mb-5 pt-1 px-1 pb-2 animate__animated animate__fadeInUp animate__faster"
            style={{ border: "1px solid #d2dae0" }}>
            <div class="card-body px-4 px-sm-5">
              <Formik
                initialValues={{ rememberMe: true }}
                onSubmit={onSubmit}>
                {() =>
                  <Form>
                    <div class="text-center">
                      <div class="mb-4 mt-1">
                        <h1 class="display-4">{l("Iniciar Sesión%VB011")}</h1>
                        {/* Temp hide 250911
                        <p>{l("¿Aún no tienes una cuenta?%VB045")} 
                          <Link to="/signup" className="ml-1">{l("Regístrate aquí%VB046")}</Link>
                        </p>
                        */}
                      </div>
                    </div>

                    {/* Email */}
                    <div class="form-group">
                      <label class="input-label" for="formEmail">{l("Usuario%VB012")}</label>
                      <Field type="email" name="email" id="formEmail"
                        class="form-control form-control-lg" tabindex="1"
                        placeholder="email@address.com" maxlength="512"
                        required autofocus="1" />
                    </div>

                    {/* Password */}
                    <div class="form-group">
                      <label class="input-label" for="formPassword">
                        <span class="d-flex justify-content-between align-items-center">
                          {l("Contraseña%VB013")}
                          <Link class="input-label-secondary" to="/recover_password" tabindex="-1">
                            {l("¿Olvidaste tu contraseña?%VB016")}
                          </Link>
                        </span>
                      </label>

                      <PasswordField name="password" placeholder={l("Contraseña%VB013")} />
                    </div>

                    {/* Remember me */}
                    <div class="form-group">
                      <div class="custom-control custom-checkbox">
                        <Field id="formRememberMe" type="checkbox" name="rememberMe"
                          class="custom-control-input" tabindex="-1" />
                        <label class="custom-control-label text-muted" for="formRememberMe">
                          {l("Recordar cuenta%VB017")}
                        </label>
                      </div>
                    </div>


                    <button type="submit" class="btn btn-lg btn-block btn-accent" tabindex="1"
                      onClick={() => Analytics.CreateEvent("App-Button-Iniciar sesión")}>
                      {l("Iniciar sesión%VB011")}
                    </button>

                    {error ?
                      <div class="alert alert-soft-danger text-center mt-2" role="alert">
                        {error}
                      </div> : null}

                    {/* Divider */}
                    <span class="divider text-muted mb-4 mt-4">O</span>

                    {/* Google and Microsoft Login Buttons */}
                    <div className="form-group mb-1">
                      <button type="button" className="btn btn-lg btn-block btn-outline-secondary mb-2" onClick={onMicrosoftLogin}>
                        <i className="fab fa-microsoft" style={{ marginRight: '8px' }}></i>
                        {l("Iniciar sesión con Microsoft%VB014")}
                      </button>
                      <button type="button" className="btn btn-lg btn-block btn-outline-secondary" onClick={onGoogleLogin}>
                        <i className="fab fa-google" style={{ marginRight: '8px' }}></i>
                        {l("Iniciar sesión con Google%VB015")}
                      </button>
                    </div>

                  </Form>}
              </Formik>
            </div>
          </div>

        </div>
      </div>

      {isLoading ? <div style={{ marginTop: "-30rem" }}><Loading /></div> : null}

    </div>


  </main>;

export default LoginView;